import React from 'react';
import RibbonSection from 'containers/Ribbon/RibbonSection';
import ShelvesHeightSelector from 'containers/Ribbon/ShelvesRibbon/ShelvesHeightSelector/ShelvesHeightSelector';
import sizeDepth from 'assets/images/size/depth.svg';
import { marksHeight } from 'containers/Ribbon/ShelvesRibbon/constants';
import DrawersOptions from 'containers/DrawersCompositionPanel/DrawersOptions';
import { setShelfHeight } from 'containers/Configurator/actions/furniture';
import { useTranslation } from 'react-i18next';
import { Shelf } from 'lib/modelBuilder/entities/Shelf';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'containers/DrawersCompositionPanel/types';
import {
  makeSelectShelvesLevelSelected,
  makeSelectShelvesSelected,
} from 'containers/Configurator/selectors/selection';
import { makeSelectShelves } from 'containers/Configurator/selectors/furniture';
import { makeSelectCommonHeight } from 'containers/Ribbon/ShelvesRibbon/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { makeSelectContext } from '../Configurator/selectors/general';
import { FurnitureEditorContext } from '../../lib/constraintsChecker/FurnitureEditor';

// import styled from 'styled-components';

interface StateProps {
  shelvesLevelSelected: number[];
  shelvesSelected: Shelf[];
  shelvesCabinet: Shelf[];
  commomHeight: number | undefined;
  context: FurnitureEditorContext;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  shelvesLevelSelected: makeSelectShelvesLevelSelected(),
  shelvesSelected: makeSelectShelvesSelected(),
  shelvesCabinet: makeSelectShelves(),
  commomHeight: makeSelectCommonHeight(),
  context: makeSelectContext(),
});

const DrawerCompositionPanelContent = () => {
  const dispatch = useDispatch();
  const {
    shelvesLevelSelected,
    shelvesCabinet,
    shelvesSelected,
    commomHeight,
    context,
  } = useSelector(stateSelector);
  const { t } = useTranslation();
  const updateSelectedHeight = (value: number, preview: boolean): void => {
    dispatch(setShelfHeight(value, shelvesLevelSelected, preview));
  };
  return (
    <div className="drawers-options-container flex w-full">
      <RibbonSection title={t('Height')}>
        <div className="lg:w-40 xl:w-48">
          <ShelvesHeightSelector
            commonHeight={commomHeight}
            icon={sizeDepth}
            handleInput={updateSelectedHeight}
            min={100}
            max={470}
            marks={
              context === FurnitureEditorContext.webShop
                ? [...marksHeight.slice(1, 3), ...marksHeight.slice(5, 8)]
                : marksHeight.slice(1, 8)
            }
            allShelves={shelvesCabinet.length === shelvesSelected.length}
            shelvesSelected={shelvesSelected}
            custom={false}
          />
        </div>
      </RibbonSection>
      <RibbonSection>
        <div className="flex justify-center">
          <DrawersOptions />
        </div>
      </RibbonSection>
    </div>
  );
};

export default DrawerCompositionPanelContent;
